import { render, staticRenderFns } from "./SwiperTable.vue?vue&type=template&id=34c5e912&scoped=true&"
import script from "./SwiperTable.vue?vue&type=script&lang=js&"
export * from "./SwiperTable.vue?vue&type=script&lang=js&"
import style0 from "./SwiperTable.vue?vue&type=style&index=0&id=34c5e912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c5e912",
  null
  
)

export default component.exports